















import { Component, mixins, Prop } from 'nuxt-property-decorator'
import MixinGeneral from '~/assets/mixins/general'
import ComponentHeaderWithLink from '~/components/header/header-with-link.vue'
import ComponentVideoItem from '~/components/video/video-item.vue'
import { VIDEO_PATH } from '~/assets/config/path'
import { filterUrl } from '~/assets/filters/url'
import { IVideoItem } from '~/assets/interfaces/video'

@Component({
  components: {
    ComponentVideoItem,
    ComponentHeaderWithLink,
  },
  filters: {
    filterUrl,
  },
})
export default class ComponentPageIndexVideoContent extends mixins(
  MixinGeneral
) {
  @Prop({ type: Array, default: () => [] }) readonly items!: IVideoItem[]
  @Prop({ type: String, default: '' }) readonly title!: string

  private VIDEO_PATH = VIDEO_PATH
}
